export enum HtmlForLoopIdentifiers {
    Index = "$index",
    Count = "$count",
    First = "$first",
    Last = "$last",
    Even = "$even",
    Odd = "$odd",
}